module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "o-account-setup"
  }, [_c('app-navigation', {
    attrs: {
      "currentSpace": _vm.$t('web.signup.nav_space')
    }
  }), _vm._v(" "), _c('main', {
    staticClass: "o-account-setup__main"
  }, [(_vm.successMessage === '') ? _c('div', {
    staticClass: "c-card js-account-setup-validation-shake"
  }, [_c('form', [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.signup.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body"
  }, [_c('div', {
    staticClass: "c-card__paragraph s-html",
    domProps: {
      "innerHTML": _vm._s(_vm.signup.text)
    }
  }), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "primary_email"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.signup.email_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.primary_email),
      expression: "request.primary_email"
    }],
    class: {
      'is-not-valid': _vm.errors.primary_email
    },
    attrs: {
      "id": "primary_email",
      "type": "text",
      "placeholder": "",
      "name": "primary_email"
    },
    domProps: {
      "value": (_vm.request.primary_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "primary_email", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.primary_email), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "u-label",
    attrs: {
      "for": "first_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.signup.first_name_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.first_name),
      expression: "request.first_name"
    }],
    class: {
      'is-not-valid': _vm.errors.first_name
    },
    attrs: {
      "id": "first_name",
      "type": "text",
      "placeholder": "",
      "name": "first_name"
    },
    domProps: {
      "value": (_vm.request.first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "first_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.first_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "last_name"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.signup.last_name_label')) + "*")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.last_name),
      expression: "request.last_name"
    }],
    class: {
      'is-not-valid': _vm.errors.last_name
    },
    attrs: {
      "id": "last_name",
      "type": "text",
      "placeholder": "",
      "name": "last_name"
    },
    domProps: {
      "value": (_vm.request.last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.request, "last_name", $event.target.value)
      }
    }
  }), _vm._v(" "), _vm._l((_vm.errors.last_name), function(error) {
    return _c('div', [_c('div', {
      staticClass: "c-validation t-alert-danger"
    }, [_vm._v(_vm._s(error))])])
  })], 2), _vm._v(" "), (_vm.showLocales) ? _c('fieldset', {
    staticClass: "o-fieldset"
  }, [_c('label', {
    staticClass: "c-card__subtitle-h3",
    attrs: {
      "for": "locale"
    }
  }, [_vm._v(_vm._s(_vm.$t('web.signup.locale_label')) + "*")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.request.locale),
      expression: "request.locale"
    }],
    class: {
      'is-not-valid': _vm.errors.last_name
    },
    attrs: {
      "id": "locale",
      "text": "Select locale",
      "name": "locale"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.request, "locale", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.locales), function(locale) {
    return _c('option', {
      domProps: {
        "value": locale.locale
      }
    }, [_vm._v(" " + _vm._s(locale.name) + " ")])
  }), 0)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.signup.fields), function(field) {
    return _c('fieldset', {
      staticClass: "o-fieldset c-card--submit-claim__fieldset"
    }, [_c(_vm.getFieldComponentType(field), {
      tag: "component",
      attrs: {
        "field": field,
        "errors": _vm.errors,
        "name": field.name,
        "className": "c-card__subtitle-h3"
      },
      model: {
        value: (_vm.request[field.name]),
        callback: function($$v) {
          _vm.$set(_vm.request, field.name, $$v)
        },
        expression: "request[field.name]"
      }
    }), _vm._v(" "), _vm._l((_vm.errors[field.name]), function(error) {
      return _c('div', [_c('div', {
        staticClass: "c-validation t-alert-danger"
      }, [_vm._v(_vm._s(error))])])
    })], 2)
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  }, [_c('button', {
    staticClass: "c-button c-button--full-width t-button t-button-primary",
    attrs: {
      "disabled": _vm.processingForm
    },
    on: {
      "click": function($event) {
        return _vm.submit($event)
      }
    }
  }, [_vm._v("\n           " + _vm._s(_vm.$t('web.signup.signup_button_text')) + "\n          ")])])])]) : _c('div', {
    staticClass: "c-card js-account-setup-validation-shake"
  }, [_c('div', {
    staticClass: "c-card__header"
  }, [_c('h2', {
    staticClass: "c-card__title t-headline"
  }, [_vm._v(_vm._s(_vm.$t('web.signup.card_header')))])]), _vm._v(" "), _c('div', {
    staticClass: "c-card__body u-margin-bottom-15 u-margin-top-15"
  }, [_c('div', {
    staticClass: "c-card__paragraph s-html",
    domProps: {
      "innerHTML": _vm._s(_vm.successMessage)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-card__footer"
  })])]), _vm._v(" "), _c('app-footer')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a23e088"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Signup.vue
// module id = 532
// module chunks = 1